<template>
  <header class="header-wrap">
    <div class="top">
      <div style="display: flex;align-items: center;">
        <img src="../assets/img/logo1.png" class="logo" alt="">
        <img src="../assets/img/logo2.png" class="logo1" alt="">
      </div>
      <ul class="nav">
        <li class="nav-item" :class="{active:activeIndex==index}" v-for="(item,index) in navL" :key="index" @mousemove="addActive(index)" @click="activeClick(index)">
          <a>{{ item.name }}</a>
        </li>
      </ul>
      <div style="display: flex;align-items: center;justify-content: center;"><img src="../assets/img/person.png" style="height: 30px;margin-right: 10px;" alt=""><span>欢迎，{{ name }}</span></div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%" :append-to-body="true" class="dialog">
      <div slot="title" class="dialog-title">
        <i class="el-icon-edit-outline"></i>
        <span class="title-text">修改密码</span>
        <div class="button-right">
          <span style="color: #000;" class="title-close" @click="dialogVisible = false"></span>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="旧密码">
          <el-input placeholder="请输入旧密码" v-model="form.oldPass" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请输入新密码" v-model="form.newPass" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input placeholder="请确认新密码" v-model="form.npwd" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </span>
    </el-dialog>
  </header>
</template>

<script>
export default {
  data() {
    return {
      name:JSON.parse(sessionStorage.getItem('userInfo')).Account,
      form:{},
      input:'',
      dialogVisible: false,
      activeIndex: 6,
      navL: [{ name: '首页', path: '/' }, { name: '模拟考试', path: '/ExamList' }, { name: '已考列表', path: '/ExamedList' }, { name: '修改密码' }, { name: '退出' },],
    }
  },
  mounted() {

    this.navL.map((item, index) => {
      if (item.path === this.$route.path) {
        this.activeIndex = index
        console.log(this.activeIndex)
      }
    })
  },
  methods: {
    addActive(index) {
      this.activeIndex = index
    },

    activeClick(index) {
      if (index === 0 || index === 1 || index === 2) {
        this.$router.push({
          path: this.navL[index].path
        })
      } else if (index === 3) {
        this.dialogVisible = true
      } else {
        this.$confirm('退出当前登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'del-model',
          type: 'warning'
        }).then(() => {
          sessionStorage.clear()
          this.$router.go(0)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          });
        });
      }
    },
    update(){
      if(this.form.newPass!==this.form.npwd){
        this.$message.error('新密码输入不一致')
        return
      }
         let params={
          Id:JSON.parse(sessionStorage.getItem('userInfo')).Id,
          Account:JSON.parse(sessionStorage.getItem('userInfo')).Account,
          Name:JSON.parse(sessionStorage.getItem('userInfo')).Name,
          Province:JSON.parse(sessionStorage.getItem('userInfo')).Province,
          SchoolId:JSON.parse(sessionStorage.getItem('userInfo')).SchoolId,
          District:JSON.parse(sessionStorage.getItem('userInfo')).District,
          City:JSON.parse(sessionStorage.getItem('userInfo')).City,
          Password:this.form.newPass
         }
         this.$api.HJAddOrUpdateManager(params).then(res=>{
          if(res.Success){
            this.$message.success('密码修改成功')
            this.dialogVisible=false
          }else this.$message.error(res.Msg)
         })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrap {
  width: 100%;
  height: 76px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  .top {
    max-width: 1100px;
    height: 76px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    .logo {
      height: 66px;
    }
    .logo1 {
      height: 40px;
    }
    .nav {
      width: 60%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 !important;
      list-style: none;
      .nav-item {
        margin: 0 25px;
        position: relative;
        white-space: nowrap;
        cursor: pointer;
        a {
          color: #666;
          font-size: 16px;
          font-weight: 400;
          text-decoration: none;
        }
      }
      .active {
        a {
          color: #4384f4;
        }
        ::after {
          background: #4384f4;
          display: block;
          content: "";
          width: 30px;
          height: 3px;
          border-radius: 2px;
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
.dialog {
  ::v-deep .el-dialog__header {
    background-color: #4384f4;
    .dialog-title {
      color: #ffffff;
      i {
        font-size: 18px;
      }
      span {
        font-size: 15px;
      }
    }
  }
  ::v-deep .el-dialog__close {
    color: #ffffff;
    font-size: 16px;
  }
  ::v-deep .el-dialog__footer {
    padding-top: 0;
  }
}
</style>